<template>
  <section
    v-if="show"
    class="h-transfer"
    :class="[tabConfig.length == 1 ? 'single-tab' : '']"
  >
    <div class="mask"></div>
    <!-- 内容面板 -->
    <div class="transfer__content">
      <!-- 面板顶部标题 -->
      <header class="transfer__header">
        <i class="el-icon-s-custom"></i>
        选择{{ title }}
        <i class="el-icon-close" @click="closeTransfer"></i>
      </header>
      <!-- 穿梭框主要内容 -->
      <div class="transfer__body">
        <!-- 左边穿梭框 start -->
        <div class="transfer-pane">
          <!-- 穿梭框 -->
          <div class="transfer-pane__body" style="height: 440px;">
            <div v-show="isEnough" class="enough-mask">
              <span class="p-center">最多选择{{ maxNum }}项</span>
            </div>
            <el-scrollbar style="height: 100%; background: #fff;">
              <el-tree
                ref="treeRef"
                show-checkbox
                :data="treeData"
                :props="{
                  children: 'children',
                  label: 'name'
                }"
                node-key="id"
                default-expand-all
                check-on-click-node
                :check-strictly="true"
                :filter-node-method="filterNode"
                @check-change="(data, checked) => changeTree(data, checked)"
              >
              </el-tree>
            </el-scrollbar>
          </div>
        </div>
        <!-- 左边穿梭框 end -->
        <!-- 右边穿梭框 start -->
        <div class="transfer-pane">
          <div class="transfer-pane__tools">
            <el-input
              v-model="searchTreeKey"
              class="search-input"
              size="mini"
              type="search"
              placeholder="搜索部门/人员"
              :disabled="!searchable"
            ></el-input>
            <span>
              <span style="margin-right: 1rem;font-size: 14px;"
                >{{ selectedData.length }} / {{ maxNum }}</span
              >
              <el-tooltip placement="top" content="清空">
                <i class="el-icon-delete" @click="removeAll"></i>
              </el-tooltip>
            </span>
          </div>
          <el-scrollbar class="transfer-pane__body shadow right-pane">
            <div
              v-for="(item, index) in selectedData"
              :key="index"
              class="selected-item"
            >
              <span>
                <span>{{ item.name }}</span>
              </span>
              <i class="el-icon-delete" @click="removeData(item, index)"></i>
            </div>
          </el-scrollbar>
          <footer class="transfer__footer">
            <el-button plain size="small" @click="closeTransfer"
              >取消</el-button
            >
            <el-button type="primary" size="small" @click="confirm"
              >确定</el-button
            >
          </footer>
        </div>
        <!-- 右边穿梭框 end -->
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "FcOrgTransfer",
  props: {
    // 公司数据
    companyList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // v-model 已经选择过的数据 用于回显
    value: {
      type: Array,
      default: () => []
    },
    /*
      类型
      role 部门/角色
      user 人员
    */
    type: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: "组织机构"
    },
    show: {
      type: Boolean,
      reuired: true
    },
    // 是否支持模糊查询
    searchable: {
      type: Boolean,
      default: true
    },
    // 可选择的最大数量
    maxNum: {
      type: Number,
      default: 99
    }
  },
  data() {
    return {
      selectedData: [], // 用户手动选择的节点(在tree里面已经显示的节点)
      aloneCheckedData: [], // 已有的 但是未在tree中渲染的数据 例如回显时的数据
      isEnough: false, // 是否选择了足够的人数
      activeTabName: "",
      tabConfig: [],
      tabKeys: [],
      treeData: [],
      searchTreeKey: "",
      allTree: []
    };
  },
  watch: {
    show: {
      handler: function(show) {
        if (show) {
          this.init();
        }
      },
      immediate: true
    },
    searchTreeKey(val) {
      this.searchData();
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    // 初始化
    init() {
      this.queryCompany();
    },
    // 初始化选中
    initSelect() {
      let ids = _.map(this.value, "targetId");
      let targetIdList = [];
      let newIds = [];
      let allTarget = _.filter(this.allTree, e => ids.includes(e.targetId));
      allTarget.map(e => {
        if (!targetIdList.includes(e.targetId)) {
          targetIdList.push(e.targetId);
          newIds.push(e.id);
        }
      });
      this.$nextTick(() => {
        this.$refs.treeRef && this.$refs.treeRef.setCheckedKeys(newIds);
      });
    },
    // 处理数据
    formatArray(array) {
      let userType = workFlowConfig.userType;
      array.map(item => {
        if (item.children && this.type === "role") {
          item.disabled = true;
          if (item.children[0].organType === userType) {
            item.children = null;
            item.disabled = false;
          }
        }
        if (this.type === "user" && item.organType !== userType) {
          item.disabled = true;
        }
        this.allTree.push(item);
        if (item.children) {
          this.formatArray(item.children);
        }
      });
    },
    // 树数据过滤
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    // 查询公司数据
    queryCompany() {
      this.allTree = [];
      let list = _.cloneDeep(this.companyList);
      this.formatArray(list);
      this.treeData = list;
      this.initSelect();
    },
    // 搜索数据
    searchData() {
      this.$refs.treeRef.filter(this.searchTreeKey);
    },
    // 树结构改变
    changeTree(data, checked) {
      this.isEnough = false;
      let index = this.selectedData.findIndex(t => t.id === data.id);
      if (index > -1) {
        this.selectedData.splice(index, 1);
      } else {
        this.selectedData.push(data);
      }
      if (this.selectedData.length >= this.maxNum) {
        this.isEnough = true;
      }
      this.aloneCheckedData = _.cloneDeep(this.selectedData);
    },
    // 删除
    removeData(data, index) {
      this.$refs.treeRef.setChecked(data.id, false);
    },
    // 清空
    removeAll() {
      this.$refs.treeRef.setCheckedKeys([]);
      // this.selectedData = [];
    },
    // 取消
    closeTransfer() {
      this.$emit("update:show", false);
      this.searchTreeKey = "";
      this.removeAll();
      this.selectedData = [];
    },
    // 确定
    confirm() {
      this.selectedData.map(item => {
        let companyName = _.find(this.treeData, {
          targetId: item.companyId
        });
        item.companyName = companyName ? companyName.name : "";
      });
      let selectedData = _.uniqBy(this.selectedData, "targetId");
      this.$emit("confirm", selectedData);
      this.closeTransfer();
    }
  }
};
</script>
<style lang="less">
.h-transfer {
  text-align: left;
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 2999;
  line-height: 32px;

  > .mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
  }

  .el-tabs--border-card {
    box-shadow: none;
  }

  .el-tabs__content {
    overflow: visible;
    min-height: 250px;
  }

  .el-tabs__nav {
    width: 100%;
    display: flex;

    > .el-tabs__item {
      flex-grow: 1;
    }
  }

  &.single-tab .el-tabs__item {
    text-align: center;
    background: #f5f7fa !important;
    border-bottom: 1px solid #e4e7ed;
    border-right-width: 0px;
  }

  .searchResPane {
    position: absolute;
    overflow-y: auto;
    z-index: 99;
    left: 0;
    top: 100%;
    width: 100%;
    height: 100%;
    background: white;
    border: 1px solid #dcdfe6;
    transition: top 0.5s;

    &.active {
      top: 0;
    }
    .hidden-tag {
      color: #999;
      font-size: 12px;
      text-align: right;
      padding-top: 4px;
      padding-right: 12px;
      cursor pointer &:hover {
        color: #66b1ff;
      }
    }

    .item {
      padding: 4px 14px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      line-height: 1.5;
      &:hover {
        background-color: #ecf5ff;
        color: #66b1ff;
        cursor: pointer;
      }

      .search-res-tip {
        font-size: 12px;
        color: #999;
        max-width: 280px;
      }
    }
  }

  .enough-mask {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    color: white;
    font-size: 16px;
    z-index: 100;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    letter-spacing: 4px;
  }

  .p-center {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .transfer__content {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 800px;
    background: rgba(255, 255, 255, 0.95);
    overflow: hidden;
    border-radius: 10px;
  }

  .transfer__header {
    margin-bottom: 6px;
    background: rgba(27, 24, 166, 0.7);
    padding: 6px 24px;
    color: white;
    .el-icon-close {
      cursor: pointer;
      float: right;
      margin-top: 10px;
    }
  }

  .transfer__body {
    padding: 12px 6px;
    display: flex;
    justify-content: space-around;
  }

  .transfer-pane {
    flex: 1;
    padding: 0 6px;
    /deep/ .el-scrollbar__wrap {
      overflow-x: hidden;
      padding: 10px;
    }
  }
  .search-input {
    flex: 1;
    margin-right: 15px;
    input {
      border: 1px solid #dcdfe6 !important;
      &:focus {
        border-color: #409eff !important;
      }
    }
  }

  .transfer-pane__tools {
    margin-bottom: 10px;
    height: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    span:last-child {
      cursor: pointer;
    }
  }

  .transfer-pane__body {
    position: relative;
    width: 100%;
    height: 330px;
    overflow: hidden;
    font-size: 14px;

    > .el-scrollbar__view {
      height: 100%;
    }

    .el-tabs__item {
      height: 26px;
      line-height: 26px;
    }
  }

  .transfer-icons {
    display: flex;
    flex-direction: column;
    justify-content: center;

    i {
      margin-top: 20px;
      margin-bottom: 20px;
      cursor: pointer;
      font-size: 20px;
      color: #696969;

      &:hover {
        transform: scale(1.1);
      }
    }
  }

  .tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;

    .node-label {
      max-width: 250px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: inline-block;
    }

    .node-checkbox {
      position: absolute;
      right: 0;
    }

    i {
      &:hover {
        color: #1485f8;
        cursor: pointer;
      }

      font-size: 10px;
    }
  }

  .right-pane {
    box-sizing: border-box;
    overflow-x: hidden;
    height: 360px;
    margin-bottom: 10px;

    .selected-item {
      padding-right: 24px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      &:hover {
        background-color: #f5f7fa;
      }

      span {
        max-width: 90%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      i {
        &:hover {
          color: #1485f8;
          cursor: pointer;
        }
      }
    }
  }

  .dot {
    width: 2px;
    height: 2px;
    display: inline-block;
    border-radius: 50%;
    background: #4caf50;
  }

  .text-ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .transfer__footer {
    text-align: right;
  }
}
</style>
